import env from "./env";

export const appConfig = Object.freeze({
  title: env.APP_TITLE,
  subTitle: env.APP_SUB_TITLE,
  variant: env.APP_VARIANT,
  // variant: "TALKVIT",
});